import {LIST_CATEGORY , UPDATE_CATEGORY , DELETE_CATEGORY } from './categoryTypes'

export default {
  [LIST_CATEGORY](state, data) {
    state.categoryList = data;
  },
  [DELETE_CATEGORY](state, data){
    const ItemIndex = state.categoryList.findIndex((p) => p.id == data.id)
    state.categoryList.splice(ItemIndex, 1)
  },
  [UPDATE_CATEGORY](state ,data){
    const productIndex = state.categoryList.findIndex((p) => p.id == data.id)
    Object.assign(state.categoryList[productIndex], data)
  },
}
